import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ProjectAdminContainerStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  height: 100%;
`;
export const ProjectAdminHeaderStyled = styled(Box).attrs({ px: { sm: '500' }, pt: { sm: '600' }, pb: { sm: '550' } })`
  ${({ theme }) => css`
    background-image: linear-gradient(275deg, ${theme.colors.bechtel.blue[1000]}, ${theme.colors.bechtel.blue[800]});
  `}
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
  z-index: 1;
`;

export const ProjectAdminTabStyled = styled(Box).attrs({ pt: { sm: '100' } })`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
`;
